
import { Component, Prop, Vue } from "vue-property-decorator";
import { TSocItem_Table } from "@/models/soc_items";

const CLASS = "soc-item-description";

const MESSAGES = {
  labels: {
    jobDescription: "Job description",
    entry: "Entry requirements of this job",
    tasks: "Tasks",
  },
};

@Component
export default class SocTableItem extends Vue {
  @Prop({ type: Object, default: () => ({}) }) readonly src?: TSocItem_Table;
  @Prop({ type: Boolean, default: false }) readonly small?: boolean;

  messages = MESSAGES;

  errorMessage = `The SOC code you selected can only be used for individuals who got CoS for the first Skilled Worker visa before July 22nd, 2025 and have continually held one or more Skilled Worker visas since then. For further instructions and guidance, please follow this <a href="https://compliance.nationbetter.uk/#/expert/guide/104" target="_blank" style="text-decoration: underline; font-weight: 600;">guide</a>.`;

  get hasControls() {
    return !!this.$slots.controls;
  }

  capitalizeFirstLetter(str: string): string {
    return `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
  }

  get title() {
    if (!this.src) return "";

    const { soc_code, job_title } = this.src;

    return `${soc_code}: ${job_title}`;
  }

  get classes() {
    const { small } = this;

    return {
      [`${CLASS}_small`]: small,
    };
  }
}
